import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, Mail } from "lucide-react";
import { scrollToId, scrollToTop } from "../../lib/scroll";

const MENU = [
    { id: "o-nas", label: "O nas" },
    { id: "uslugi", label: "Usługi" },
    { id: "realizacje", label: "Realizacje" },
    { id: "opinie", label: "Opinie" },
    { id: "kontakt", label: "Kontakt" },
];

const SERVICES = ["Elektryka", "Hydraulika", "Wykończenia", "Układanie płytek", "Montaż", "Drobne naprawy", "Wywóz odpadów", "Sprzątanie mieszkań"];

export default function Footer() {
    return (
        <footer className="relative overflow-hidden bg-ink text-white">
            <div className="bg-noise pointer-events-none absolute inset-0 opacity-[0.05]" aria-hidden />
            <div className="relative mx-auto max-w-7xl px-6 pb-10 pt-20 md:px-12">
                <button
                    data-testid="footer-logo"
                    onClick={scrollToTop}
                    className="font-display text-6xl font-black tracking-tighter transition-colors duration-300 hover:text-gold md:text-8xl"
                    aria-label="Handy's — do góry strony"
                >
                    Handy<span className="text-gold">&rsquo;</span>s
                </button>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-white/50">
                    Kompleksowe usługi remontowo-techniczne dla domów, mieszkań i lokali.
                    Solidnie. Terminowo. Z gwarancją.
                </p>

                <div className="mt-14 grid grid-cols-2 gap-10 border-t border-white/10 pt-12 md:grid-cols-4">
                    <div>
                        <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-white/40">Menu</h4>
                        <ul className="space-y-3">
                            {MENU.map((m) => (
                                <li key={m.id}>
                                    <button
                                        data-testid={`footer-link-${m.id}`}
                                        onClick={() => scrollToId(m.id)}
                                        className="text-sm text-white/70 transition-colors duration-300 hover:text-gold"
                                    >
                                        {m.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-white/40">Usługi</h4>
                        <ul className="space-y-3">
                            {SERVICES.map((s) => (
                                <li key={s}>
                                    <button onClick={() => scrollToId("uslugi")} className="text-sm text-white/70 transition-colors duration-300 hover:text-gold">
                                        {s}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-white/40">Kontakt</h4>
                        <ul className="space-y-3">
                            <li>
                                <a data-testid="footer-phone" href="tel:+48512913717" className="flex items-center gap-2 text-sm text-white/70 transition-colors duration-300 hover:text-gold">
                                    <Phone className="h-4 w-4 text-gold" /> +48 512 913 717
                                </a>
                            </li>
                            <li>
                                <a data-testid="footer-email" href="mailto:handyskrakow@gmail.com" className="flex items-center gap-2 text-sm text-white/70 transition-colors duration-300 hover:text-gold">
                                    <Mail className="h-4 w-4 text-gold" /> handyskrakow@gmail.com
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-white/40">Obserwuj</h4>
                        <div className="flex gap-3">
                            <a
                                data-testid="footer-facebook"
                                href="https://www.facebook.com/share/19XGcWK2LS/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                                className="rounded-full border border-white/15 p-3 text-white/70 transition-[background-color,border-color,color] duration-300 hover:border-gold hover:bg-gold hover:text-ink"
                            >
                                <Facebook className="h-4 w-4" />
                            </a>
                            <a
                                data-testid="footer-instagram"
                                href="https://www.instagram.com/handys_krakow"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                                className="rounded-full border border-white/15 p-3 text-white/70 transition-[background-color,border-color,color] duration-300 hover:border-gold hover:bg-gold hover:text-ink"
                            >
                                <Instagram className="h-4 w-4" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/40 sm:flex-row">
                    <p>© 2026 Handy&rsquo;s — Jan Białoń. Wszelkie prawa zastrzeżone.</p>
                    <Link data-testid="footer-admin-link" to="/admin" className="transition-colors duration-300 hover:text-gold">
                        Panel administratora
                    </Link>
                </div>
            </div>
        </footer>
    );
}
